export default __webpack_public_path__ + "static/media/credit_card.db88aa55.svg";